<template>
  <div class="ag-cell-list-item clinician-patients-list">
    <a
      class="ag-cell-click"
      @click="showDetail"
    >
      {{ episodeId }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'EpisodeCellRenderer',
  data () {
    return {
      episodeId: ''
    }
  },
  beforeMount () {
    this.episodeId = this.params.data.episode_id
  },
  methods: {
    showDetail () {
      // invoke method from parent
      this.params.context.homepageGrid.openDetail(this.params.data)
    }
  }
}
</script>
